/**
 * Pure SVG path math for the Health sparkline charts.
 */

/** Monotone cubic spline interpolation for smooth curves */
export function smoothPath(pts: { x: number; y: number }[]): string {
  if (pts.length < 2) return '';
  if (pts.length === 2) return `M${pts[0].x},${pts[0].y}L${pts[1].x},${pts[1].y}`;

  // Compute tangents using monotone method (Fritsch-Carlson)
  const n = pts.length;
  const dx: number[] = [];
  const dy: number[] = [];
  const m: number[] = [];
  for (let i = 0; i < n - 1; i++) {
    dx.push(pts[i + 1].x - pts[i].x);
    dy.push(pts[i + 1].y - pts[i].y);
    m.push(dy[i] / dx[i]);
  }
  const tangents: number[] = [m[0]];
  for (let i = 1; i < n - 1; i++) {
    if (m[i - 1] * m[i] <= 0) tangents.push(0);
    else tangents.push(2 / (1 / m[i - 1] + 1 / m[i]));
  }
  tangents.push(m[n - 2]);

  let d = `M${pts[0].x},${pts[0].y}`;
  for (let i = 0; i < n - 1; i++) {
    const seg = dx[i] / 3;
    d += `C${pts[i].x + seg},${pts[i].y + tangents[i] * seg},${pts[i + 1].x - seg},${pts[i + 1].y - tangents[i + 1] * seg},${pts[i + 1].x},${pts[i + 1].y}`;
  }
  return d;
}
